import { render, staticRenderFns } from "./JSonExcel.vue?vue&type=template&id=1165dc36&"
import script from "./JSonExcel.vue?vue&type=script&lang=js&"
export * from "./JSonExcel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports